import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL; // Your Node.js server

const socket = io(SOCKET_URL);

export default socket;
